export function setToken(token) {
  const cookie = makeCookie(token)
  setCookie(cookie)
}

export function getToken() {
  return getCookie('macro_sso_token')
}

export function removeToken() {
  const cookie = makeCookie()
  cookie['max-age'] = 0
  setCookie(cookie)
}

function makeCookie(token = '') {
  return {
    macro_sso_token: token,
    domain: process.env.VUE_APP_DOMAIN,
    'max-age': 60 * 60 * 4, // 4 hour
  }
}

function setCookie(data) {
  const newCookie = Object.entries(data)
    .map(([key, value]) => `${key}=${value}`)
    .join('; ')
  document.cookie = newCookie
}

function getCookie(key) {
  const cookies = new Map(
    document.cookie.split('; ').map((cookie) => cookie.split('='))
  )
  return cookies.get(key)
}
